import "./InteriorRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import InteriorHero from "./sections/InteriorHero";
import RemodelingGuide from "./sections/RemodelingGuide";
import InteriorRemodelingFaq from "./sections/InteriorRemodelingFaq";
import RelatedServicesEstimateForm from "./sections/RelatedServicesEstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function InteriorRemodelingPage() {
  return <div>
      <Header />
      <InteriorHero />
      <RemodelingGuide />
      <InteriorRemodelingFaq />
      <RelatedServicesEstimateForm />
      <Footer />
    </div>;
}